"use client";

import { c as _c } from "react/compiler-runtime";
import { useAIChatInputContext } from "../contexts";
import { HiOutlineX } from "react-icons/hi";
import { getFileIcon } from "@/app/[tenant]/(console)/comms/chat/window/helpers";
import Button from "@/components/ui/button";
import { cx } from "@/lib/tailwind-utils";
interface AIChatInputFilePillsProps {
  className?: string;
}
export function AIChatInputFilePills(t0) {
  const $ = _c(10);
  const {
    className
  } = t0;
  const {
    state,
    actions
  } = useAIChatInputContext();
  if (state.files.length === 0) {
    return null;
  }
  let t1;
  if ($[0] !== className) {
    t1 = cx("flex flex-wrap justify-left", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== actions || $[3] !== state.files) {
    let t3;
    if ($[5] !== actions) {
      t3 = (file, index) => <div key={`${file.name}-${file.lastModified}`} className={cx("relative mb-2 ml-1 flex max-w-sm items-center gap-2 rounded-xl px-1.5 py-1 text-primary-800 shadow-md", "cursor-pointer", "bg-background/80 backdrop-blur-sm")}>{getFileIcon(file)}<span className="truncate text-body">{file.name}</span>{actions.removeFile && <Button variant="ghost" type="button" onClick={e => {
          e.stopPropagation();
          actions.removeFile(index);
        }} className="!p-0 *:text-primary" icon={<HiOutlineX size={16} />} />}</div>;
      $[5] = actions;
      $[6] = t3;
    } else {
      t3 = $[6];
    }
    t2 = state.files.map(t3);
    $[2] = actions;
    $[3] = state.files;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[7] !== t1 || $[8] !== t2) {
    t3 = <div className={t1}>{t2}</div>;
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
}